import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  CircularProgress,
  Checkbox,
  Select,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SubModuleIcon from "../../../assets/submoduleIcon";
import DeleteIcon from "../../../assets/deleteIcon";
import FormHelperText from "@mui/material/FormHelperText";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "components/structure/Layout";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Service from "../../../services/ModulesRegistrationServices";
import { SnackbarContext } from "context/snackBarContext";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import './Module.css'
import * as Yup from "yup";
import PinkIosSwitch from "utils/PinkIosSwitch";
import RedSwitch from "utils/RedSwitch";
import { AuthData } from "auth/AuthWarpper";
import { formatDateDetails } from "utils/utils";
import CheckboxUntick from "../../../assets/CheckboxUntick.svg"
import CheckboxTick from "../../../assets/CheckboxTick.svg"

const Heading = styled.div`
  color: rgba(115, 125, 134, 1);
  font-size: 1.25rem;
  font-weight: 600;
`;

const PaperContainer = styled(Paper)`
  padding: 1rem 1rem;
  border-radius: 10px;
  background-color: white;
  height: auto;
  margin-top: 20px;
`;
const DataContainer = styled.div`
  margin-top: 2rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 2rem 0;
`;


const Line = styled.div`
  border-bottom: 1px solid lightgray;
`;

const HeaderBody = styled.div`
  height: auto;
`;

const EditRegistration = () => {
  const { user } = AuthData();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { setOpenAlert, setSeverity, setMessage, handleClose } =
    useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = useState({
    id: 1,
    mName: state?.item?.mName,
    cropStageName: state?.cropStage,
    submName: ""
  });
  const [errors, setErrors] = useState({});
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [countries, setCountries] = useState([]);
  const [subModules, setSubModules] = useState([]);

  const [switchValue, setSwitchValue] = useState(state?.item?.mStatus);
  const modifiedByUser = user?.modifiedByUser;
  const dateTimeString = "2024-04-07T07:04:48.063785Z";
  const dateTime = new Date(dateTimeString);
  const options = { year: "numeric", month: "long", day: "numeric" };
  const formattedDate = dateTime.toLocaleDateString("en-US", options);
  const timeOptions = { hour: "numeric", minute: "numeric", second: "numeric" };
  const formattedTime = dateTime.toLocaleTimeString("en-US", timeOptions);
  const formattedDateTime = `${formattedDate} ${formattedTime}`;

  const [getCropList, setCropList] = useState([]);
  const [cropStageUUID, setCropStageUUID] = useState(state?.item?.cropStageUUID || '');

  useEffect(() => {
    setSubModules(prevList => 
      prevList.map(submodule => ({
        ...submodule,
        selectedCountries: submodule.selectedCountries?.filter(country =>
          selectedCountries.some(mainCountry => mainCountry.countryId === country.countryId)
        )
      }))
    );
  }, [selectedCountries]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Service.getCroplistWithCountry();
        setCropList(response?.data?.response);
        
        // Find the selected crop stage and set its countries
        const selectedCropStage = response?.data?.response.find(
          crop => crop.cropStageId === state?.item?.cropStageUUID
        );

        if (selectedCropStage && selectedCropStage.cropStageCountryLinks) {
          const availableCountries = selectedCropStage.cropStageCountryLinks.map(country => ({
            countryId: country.countryId,
            countryCode: country.countryCode,
            countryName: country.countryName,
            localLanguage: null
          }));
          setCountries(availableCountries);
        }

      } catch (error) {
        console.error("Error fetching data:", error);
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const getModuleDetails = async () => {
      if (state?.item?.mId) {
        try {
          setLoading(true);
          const response = await Service.getModuleDetails(state.item.mId);
          // Check if response contains data
          if (response?.data) {
            const moduleData = response?.data?.response;
            console.log("Module Data:", moduleData);
            // Update form data
            setFormData(prev => ({
              ...prev,
              mName: moduleData?.mName,
              // cropStageName: moduleData?.cropStageName
              cropStageName: state?.cropStage|| moduleData?.cropStageName

            }));

            // Update countries
            if (moduleData.moduleCountryLinks) {
              const moduleCountries = moduleData.moduleCountryLinks.map(country => ({
                countryId: country.countryId,
                countryCode: country.countryCode,
                countryName: country.countryName,
                // isSafeToRemove:  country.isSafeToRemove
                isSafeToRemove:  country.isSafeToRemove !== undefined ? country.isSafeToRemove : true // Default to true if not defined

              }));
              console.log("Module Countries:", moduleCountries);
              setSelectedCountries(moduleCountries);
            }
            // Update submodules
            if (moduleData.subModule) {
              const formattedSubmodules = moduleData.subModule.map((subModule, index) => ({
                ...subModule,
                id: index + 1,
                selectedCountries: subModule.moduleCountryLinks?.map(country => ({
                  countryId: country.countryId,
                  countryCode: country.countryCode,
                  countryName: country.countryName,
                  isSafeToRemove: country.isSafeToRemove !== undefined ? country.isSafeToRemove : true // Default to true if not defined
                })) || []
              }));
              console.log("Formatted Submodules:", formattedSubmodules);
              setSubModules(formattedSubmodules);
            }

            // Update other states
            setSwitchValue(moduleData.mStatus);
            setCropStageUUID(moduleData.cropStageUUID);
          }
        } catch (error) {
          console.error("Error fetching module details:", error);
          setSeverity("error");
          setMessage(error?.response?.data?.message || "Failed to fetch module details");
          setOpenAlert(true);
        } finally {
          setLoading(false);
        }
      }
    };

    getModuleDetails();
  }, [state?.item?.mId]);
  const handleChange = (e, fieldName) => {
    setLoading(false);
    const { value, checked } = e.target;
    const val = fieldName === "isActive" ? checked : value;

    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: val,
    }));
  };

  const handleSwitchChange = (event) => {
    const newValue = event?.target?.checked;
    setSwitchValue(newValue);
  };
  const handleSubmoduleChange = (index, e) => {
    const updatedSubModules = [...subModules];
    updatedSubModules[index] = {
      ...updatedSubModules[index],
      mName: e.target.value,
    };
    setSubModules(updatedSubModules);
  };

  const handleCountryChange = (event) => {
    const { value } = event.target;
    
    // Handle "Select All" case
    if (value === "all") {
      if (selectedCountries.length === countries.length) {
        // Check if any country in any submodule has isSafeToRemove as false
        const submodulesWithLockedCountries = subModules.filter(submodule => 
          submodule.selectedCountries.some(country => country.isSafeToRemove === false)
        );
  
        if (submodulesWithLockedCountries.length > 0) {
          const submoduleNames = submodulesWithLockedCountries
            .map(sm => `"${sm.mName}"`)
            .join(", ");
          setSeverity("error");
          setMessage(`Some country is associated with one or more submodules. Please 
deselect the country from the submodules first, then try again.`);
          setOpenAlert(true);
          return;
        }
  
        setSelectedCountries([]);
        setSubModules(prevList => 
          prevList.map(submodule => ({
            ...submodule,
            selectedCountries: submodule.selectedCountries.filter(
              country => country.isSafeToRemove === false
            )
          }))
        );
      } else {
        // When selecting all countries, preserve existing isSafeToRemove values
        const countriesWithSafeValues = countries.map(country => {
          const existingCountry = subModules.flatMap(sm => sm.moduleCountryLinks)
            .find(sc => sc?.countryId === country.countryId);
          return {
            ...country,
            isSafeToRemove: existingCountry ? existingCountry.isSafeToRemove : true
          };
        });
        setSelectedCountries(countriesWithSafeValues);
        setSubModules(prevList => 
          prevList.map(submodule => ({
            ...submodule,
            selectedCountries: countriesWithSafeValues
          }))
        );
      }
      return;
    }
  
    // Handle individual country selection
    const selectedCountry = countries.find(country => 
      country.countryId === value.countryId
    );
  
    if (selectedCountry) {
      const isCurrentlySelected = selectedCountries.some(
        country => country.countryId === selectedCountry.countryId
      );
  
      if (isCurrentlySelected) {
        // Check if country is selected in any submodule with isSafeToRemove as false
        const submodulesWithLockedCountry = subModules.filter(submodule => 
          submodule.selectedCountries.some(country => 
            country.countryId === selectedCountry.countryId && 
            country.isSafeToRemove === false
          )
        );
  
        if (submodulesWithLockedCountry.length > 0) {
          const submoduleNames = submodulesWithLockedCountry
            .map(sm => `"${sm.mName}"`)
            .join(", ");
          setSeverity("error");
          setMessage(`This country is associated with one or more submodules. Please 
deselect the country from the submodules first, then try again.`);
          setOpenAlert(true);
          return;
        }
  
        // Remove country
        const newSelectedCountries = selectedCountries.filter(
          country => country.countryId !== selectedCountry.countryId
        );
        setSelectedCountries(newSelectedCountries);
        
        // Remove country from all submodules where it's not locked
        setSubModules(prevList => 
          prevList.map(submodule => ({
            ...submodule,
            selectedCountries: submodule.selectedCountries.filter(
              country => 
                country.countryId !== selectedCountry.countryId || 
                country.isSafeToRemove === false
            )
          }))
        );
      } else {
        // Add country with preserved isSafeToRemove value
        const existingCountry = subModules.flatMap(sm => sm.selectedCountries)
          .find(sc => sc.countryId === selectedCountry.countryId);
        
        const countryToAdd = {
          ...selectedCountry,
          isSafeToRemove: existingCountry ? existingCountry.isSafeToRemove : true
        };
  
        const newSelectedCountries = [...selectedCountries, countryToAdd];
        setSelectedCountries(newSelectedCountries);
        
        // Add country to all submodules
        setSubModules(prevList => 
          prevList.map(submodule => ({
            ...submodule,
            selectedCountries: [...submodule.selectedCountries, countryToAdd]
          }))
        );
      }
    }
  };

const handleSubmoduleCountryChange = (event, submoduleId) => {
  const { value } = event.target;
  
  if (value === "selectAll") {
    setSubModules((prevList) =>
      prevList.map(submodule => {
        if (submodule.mId === submoduleId) {
          return {
            ...submodule,
            selectedCountries: selectedCountries.map(country => {
              // Find original value from initial submodule data
              const originalCountry = submodule.moduleCountryLinks?.find(
                link => link.countryId === country.countryId
              );
              return {
                ...country,
                isSafeToRemove: originalCountry ? originalCountry.isSafeToRemove : true
              };
            })
          };
        }
        return submodule;
      })
    );
    return;
  }

  if (value === "deselectAll") {
    // Check if any selected country has isSafeToRemove as false
    const submodule = subModules.find(sm => sm.mId === submoduleId);
    const lockedCountries = submodule?.selectedCountries.filter(
      country => country.isSafeToRemove === false
    );

    if (lockedCountries && lockedCountries.length > 0) {
      const countryNames = lockedCountries
        .map(country => `"${country.countryName}"`)
        .join(", ");
      setSeverity("error");
      setMessage(`
Some country is associated with one or more questions. Please 
deselect the country from the questions first, then try again
`);
      setOpenAlert(true);
      return;
    }

    setSubModules((prevList) =>
      prevList.map(submodule => {
        if (submodule.mId === submoduleId) {
          return {
            ...submodule,
            selectedCountries: []
          };
        }
        return submodule;
      })
    );
    return;
  }

  if (value && value.countryId) {
    setSubModules((prevList) =>
      prevList.map(submodule => {
        if (submodule.mId === submoduleId) {
          const existingCountry = submodule.selectedCountries.find(
            country => country.countryId === value.countryId
          );

          if (existingCountry) {
            // Check if country can be removed
            if (existingCountry.isSafeToRemove === false) {
              setSeverity("error");
              setMessage(`
This country is associated with one or more questions. Please 
deselect the country from the questions first, then try again
`);
              setOpenAlert(true);
              return submodule;
            }
            
            // Remove the country
            return {
              ...submodule,
              selectedCountries: submodule.selectedCountries.filter(
                country => country.countryId !== value.countryId
              )
            };
          } else {
            // Add the country with original isSafeToRemove value
            const originalCountry = submodule.moduleCountryLinks?.find(
              link => link.countryId === value.countryId
            );
            
            const countryToAdd = {
              ...value,
              isSafeToRemove: originalCountry ? originalCountry.isSafeToRemove : true
            };
            return {
              ...submodule,
              selectedCountries: [...submodule.selectedCountries, countryToAdd]
            };
          }
        }
        return submodule;
      })
    );
  }
};

  useEffect(() => {
    if (subModules) {
    }
  }, [subModules]);

  const handleAddSubModule = () => {
    const currentDateTimeUTC = new Date().toISOString();
    const newSubModule = {
      createdDateTimeUTC: currentDateTimeUTC,
      mId: "",
      mName: "",
      mLevelId: "",
      mLevelDesc: "sub",
      mMappingId: state?.item?.mMappingId || null,
      createdByUser: user ? user.userName : "",
      modifiedByUser: user ? user.userName : "",
      cropStageUUID: state?.item?.cropStageUUID || "",
      subModule: null,
      sequence: subModules?.length + 1,
      mStatus: false,
      selectedCountries: [...selectedCountries]
    };
    let allSubModules = [...subModules, newSubModule];
    setSubModules(allSubModules);
  };

  const handleDeleteSubModule = (index, status) => {
    let allsubmodule = JSON.parse(JSON.stringify(subModules))
    allsubmodule[index]['mStatus'] = status;
    setSubModules(allsubmodule)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setErrors({});
      await validationSchema.validate(formData, { abortEarly: false });
    } catch (error) {
      let newError = {};

      error.inner.forEach((err) => {
        newError[err.path] = err.message;
      });
      setErrors(newError);
    }
  };

  const validationSchema = Yup.object({
    // mName: Yup.string().required("Module Name is required"),
    mName: Yup.string().trim()
      .matches(
        /^[^\s]+(?: [^\s]+)*$/,
        "Extra spaces not allowed"
      )
      .strict(true)
      .min(1, 'Module name needs to be at least 1 char')
      .max(60, 'Module name cannot exceed 60 char').required("Module Name  is required"),
    cropStageName: Yup.string().required("Crop Stage Name is required"),
  });

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      setErrors({});
      await validationSchema.validate(formData, { abortEarly: false });
  
      // Validate main module country selection
      if (selectedCountries.length === 0) {
        setSeverity("error");
        setMessage("Please select at least one country for the module");
        setOpenAlert(true);
        return;
      }
  
      // Validate submodule countries
      const submoduleWithoutCountries = subModules.find(
        submodule => !submodule.selectedCountries || submodule.selectedCountries.length === 0
      );
  
      if (submoduleWithoutCountries) {
        setSeverity("error");
        setMessage("Please select at least one country for each submodule");
        setOpenAlert(true);
        return;
      }
  
      // Format data and proceed with update
      const countryIds = selectedCountries.map(country => country.countryId);
  
      const formattedSubmodules = subModules.map(submodule => ({
        ...submodule,
        countryIds: submodule.selectedCountries.map(country => country.countryId),
        selectedCountries: undefined,
        mName: submodule.mName,
        mStatus: submodule.mStatus,
        mLevelId: 2,
        mLevelDesc: "sub",
        mMappingId: state?.item?.mId,
        modifiedByUser: user ? user.userName : "",
        cropStageUUID: state?.item?.cropStageUUID,
        sequence: submodule.sequence
      }));
  
      // Validate submodule names
      let subModuleError = false;
      let newError = {};
  
      subModules.forEach((ele, index) => {
        let subName = `submodule-name-${index}`;
        let regex = /^[^\s]+(?: [^\s]+)*$/;
        let valid = true;
        if (ele?.mName) {
          valid = regex.test(ele.mName);
        }
        if (ele?.mName === "" || ele?.mName === undefined) {
          newError[subName] = "Submodule name cannot be blank";
          subModuleError = true;
        }
        if (!valid) {
          newError[subName] = "Extra spaces not allowed";
          subModuleError = true;
        }
      });
  
      if (subModuleError) {
        setErrors(newError);
        return;
      }
  
      const payload = {
        subModule: formattedSubmodules,
        mName: formData?.mName ? formData?.mName : state?.item?.mName,
        mStatus: switchValue,
        mLevelId: 1,
        mLevelDesc: "main",
        mMappingId: state?.item?.mId,
        modifiedByUser: user ? user.userName : "",
        cropStageUUID: state?.item?.cropStageUUID,
        sequence: state?.item?.sequence,
        mId: state?.item?.mId,
        countryIds
      };
  
      setLoading(true);
      const response = await Service.updateModule(payload);
      
      if (response?.data) {
        setLoading(false);
        setSeverity("success");
        setMessage("Updated successfully");
        setOpenAlert(true);
        navigate("/getmoduleregistration", {
          state: {
            selectedCropStage: state?.cropStage,
            cropStageUUID: state?.item?.cropStageUUID
          }
        });
      }
    } catch (error) {
      setLoading(false);
      let newError = {};
      
      if (error?.inner) {
        error.inner.forEach((err) => {
          newError[err.path] = err.message;
        });
        setErrors(newError);
      } else {
        setSeverity("error");
        setMessage(error?.response?.data?.message || "An error occurred");
        setOpenAlert(true);
      }
    }
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return; // Item dropped outside the list
    }
    const startIndex = result.source.index;
    const endIndex = result.destination.index;
    const updatedSubmoduleList = Array.from(subModules);
    const [removed] = updatedSubmoduleList.splice(startIndex, 1);
    updatedSubmoduleList.splice(endIndex, 0, removed);

    updatedSubmoduleList.forEach((ele, index) => {
      ele.sequence = index + 1
    })
    setSubModules(updatedSubmoduleList);
  };

  const handleCancel = () => {
    subModules.forEach((ele) => {
      if (ele.mName == '') {
        let mId = ele?.mId
        Service.remove(mId).then((res) => {
        }).catch((error) => {
          console.log(error)
        })
      }
    });
    navigate("/getmoduleregistration", { state: { selectedCropStage: state?.cropStage, cropStageUUID: state?.item?.cropStageUUID } })
  }

  return (
    <Layout title="Edit Module Setup">
      <div className="moduleContainer">
        <Grid container >
          <Grid
            item
            xs={12}
            sm={9}
            md={6}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Box
              sx={{
                marginLeft: { xs: "1rem", sm: 0 },
                marginTop: { xs: 2, sm: 0 },
              }}
            >
              <Heading>Edit Module Setup</Heading>
            </Box>
            <Box
              sx={{ marginLeft: "10px", marginRight: { xs: "1rem", sm: "2rem" } }}
            >
              <Button
                sx={{
                  borderRadius: 100,
                  background: "#102A62",
                }}
                variant="contained"
                disabled={loading}
                startIcon={<AddCircleIcon />}
                onClick={handleAddSubModule}
              >   {loading && <CircularProgress size={20} />}
                Add Sub Modules
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3} md={6} sx={{ paddingTop: { xs: "1rem" } }}>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", flexDirection: "column", marginLeft: "1rem" }}
            >
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <InputLabel sx={{ margin: 0 }} htmlFor="my-input">
                  Last Modified By:
                </InputLabel>
                <Typography variant="body1"> &nbsp;{state?.item?.modifiedByUser || ""}</Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <InputLabel sx={{ margin: 0 }} htmlFor="my-input">
                  Last Modified Date:
                </InputLabel>
                <Typography variant="body1">
                  {" "}
                  &nbsp;{formatDateDetails(state?.item?.modifiedDateTimeUTC)}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <PaperContainer>
          <HeaderBody>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Grid
                container
                spacing={4}
                sx={{
                  justifyContent: "space-between",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid item xs={12} sm={12} md={4}>
                  <Grid container sx={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                    <Grid md={5} sm={6} xs={12}>
                      <InputLabel
                        htmlFor="my-input"
                        required
                      >
                        Module Name
                      </InputLabel>
                    </Grid>
                    <Grid xs={12} md={5} sm={6}>
                      <div style={{ position: "relative" }}>
                        <TextField
                          fullWidth
                          inputProps={{ maxLength: 60 }}
                          value={formData?.mName}
                          name="mName"
                          onChange={(e) => handleChange(e, "mName")}
                          placeholder="Type here"
                          required 
                          variant="outlined"
                        />
                        {errors.mName && (
                          <Box sx={{ position: "absolute", marginLeft: "", marginTop: "0.5rem" }}>
                            <FormHelperText error={true}>
                              {errors.mName}
                            </FormHelperText>
                          </Box>
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={4}>
                  <Grid container sx={{ display: "flex", justifyContent: { xs: "flex-start", sm: "center" }, alignItems: 'center' }}>
                    <Grid md={5} sm={6}>
                      <InputLabel
                        htmlFor="crop-stage-input"
                        required
                      >
                        Crop Stage Name
                      </InputLabel>
                    </Grid>
                    <Grid xs={12} md={5} sm={6}>
                      <Select
                        fullWidth
                        value={state?.item?.cropStageUUID || ''}
                        disabled
                      >
                        {getCropList.map((crop) => (
                          <MenuItem key={crop.cropStageId} value={crop.cropStageId}>
                            {crop.cropStageName}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.cropStageName && (
                        <FormHelperText error={true}>
                          {errors.cropStageName}
                        </FormHelperText>
                      )}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={4}>
                  <Grid container sx={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                    <Grid md={5} sm={6} xs={12}>
                      <InputLabel>Active</InputLabel>
                    </Grid>
                    <Grid xs={12} md={5} sm={6}>
                      <Box sx={{ marginLeft: "0" }}>
                        <Checkbox 
                          name="active"
                          checked={switchValue}
                          onChange={handleSwitchChange}
                          icon={<img src={CheckboxUntick} />}
                          checkedIcon={<img src={CheckboxTick} />}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={4}>
                  <Grid container sx={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                    <Grid md={5} sm={6} xs={12}>
                      <InputLabel
                        htmlFor="my-input"
                        required
                      >
                        Country
                      </InputLabel>
                    </Grid>
                    <Grid xs={12} md={5} sm={6}>
                      <div style={{ position: "relative" }}>
                        <Select
                          multiple
                          fullWidth
                          value={selectedCountries}
                          onChange={handleCountryChange}
                          renderValue={(selected) => 
                            selected.map(country => country.countryName).join(", ")
                          }
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 250,
                                overflowY: "auto",
                              },
                            },
                          }}
                        >
                          <MenuItem value="all">
                            <ListItemIcon>
                              <Checkbox
                                checked={selectedCountries.length === countries.length}
                                icon={<img src={CheckboxUntick} />}
                                checkedIcon={<img src={CheckboxTick} />}
                                onChange={(e) => {
                                  if (!e.target.checked) {
                                    // Check if any country in any submodule has isSafeToRemove as false
                                    const submodulesWithLockedCountries = subModules.filter(submodule => 
                                      submodule.selectedCountries.some(country => 
                                        country.isSafeToRemove === false
                                      )
                                    );
                                  
                                    if (submodulesWithLockedCountries.length > 0) {
                                      const submoduleNames = submodulesWithLockedCountries
                                        .map(sm => `"${sm.mName}"`)
                                        .join(", ");
                                      setSeverity("error");
                                      setMessage(`
This country is associated with one or more submodules. Please 
deselect the country from the submodules first, then try again.
`);
                                      setOpenAlert(true);
                                      return;
                                    }
                                  
                                    setSelectedCountries([]);
                                    setSubModules(prevList => 
                                      prevList.map(submodule => ({
                                        ...submodule,
                                        selectedCountries: submodule.selectedCountries.filter(
                                          country => country.isSafeToRemove === false
                                        )
                                      }))
                                    );
                                  } else {
                                    // When selecting all countries, preserve existing isSafeToRemove values
                                    const countriesWithSafeValues = countries.map(country => {
                                      const existingCountry = subModules.flatMap(sm => sm.moduleCountryLinks)
                                        .find(sc => sc?.countryId === country.countryId);
                                      return {
                                        ...country,
                                        isSafeToRemove: existingCountry ? existingCountry.isSafeToRemove : true
                                      };
                                    });
                                    setSelectedCountries(countriesWithSafeValues);
                                    setSubModules(prevList => 
                                      prevList.map(submodule => ({
                                        ...submodule,
                                        selectedCountries: countriesWithSafeValues
                                      }))
                                    );
                                  }
                                }}
                              />
                            </ListItemIcon>
                            <ListItemText primary="Select All" />
                          </MenuItem>
                          {countries.map((country) => (
                            <MenuItem 
                              key={country.countryId} 
                              value={country}
                              onClick={() => {
                                const isSelected = selectedCountries.some(
                                  selected => selected.countryId === country.countryId
                                );
                                
                                if (isSelected) {
                                  // Check if country is selected in any submodule
                                  const submodulesWithCountry = subModules.filter(submodule => 
                                    submodule.selectedCountries.some(sc => 
                                      sc.countryId === country.countryId && 
                                      sc.isSafeToRemove === false
                                    )
                                  );
                              
                                  if (submodulesWithCountry.length > 0) {
                                    const submoduleNames = submodulesWithCountry
                                      .map(sm => `"${sm.mName}"`)
                                      .join(", ");
                                    setSeverity("error");
                                    setMessage(`This country is associated with one or more submodules. Please 
deselect the country from the submodules first, then try again.`);
                                    setOpenAlert(true);
                                    return;
                                  }
                              
                                  const newSelectedCountries = selectedCountries.filter(
                                    selected => selected.countryId !== country.countryId
                                  );
                                  setSelectedCountries(newSelectedCountries);
                                  
                                  // Remove from all submodules where it's not locked
                                  setSubModules(prevList => 
                                    prevList.map(submodule => ({
                                      ...submodule,
                                      selectedCountries: submodule.selectedCountries.filter(
                                        sc => sc.countryId !== country.countryId || sc.isSafeToRemove === false
                                      )
                                    }))
                                  );
                                } else {
                                  // Add country with preserved isSafeToRemove value
                                  const existingCountry = subModules.flatMap(sm => sm.moduleCountryLinks)
                                    .find(sc => sc?.countryId === country.countryId);
                                  
                                  const countryToAdd = {
                                    ...country,
                                    isSafeToRemove: existingCountry ? existingCountry.isSafeToRemove : true
                                  };
                              
                                  setSelectedCountries([...selectedCountries, countryToAdd]);
                                  
                                  // Add to all submodules with same isSafeToRemove value
                                  setSubModules(prevList => 
                                    prevList.map(submodule => ({
                                      ...submodule,
                                      selectedCountries: [...submodule.selectedCountries, countryToAdd]
                                    }))
                                  );
                                }
                              }}
                            >
                              <ListItemIcon>
                                <Checkbox
                                  checked={selectedCountries.some(
                                    selected => selected.countryId === country.countryId
                                  )}
                                  icon={<img src={CheckboxUntick} />}
                                  checkedIcon={<img src={CheckboxTick} />}
                                />
                              </ListItemIcon>
                              <ListItemText primary={country.countryName} />
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </HeaderBody>

          <Box sx={{ marginTop: 5 }}>
          </Box>
          <DataContainer>
            <DragDropContext onDragEnd={onDragEnd}>
              {subModules &&
                subModules?.map((submodule, index) => (
                  <Droppable
                    key={submodule.id}
                    droppableId={`submodule-${submodule.mId}`}
                  >
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        <Draggable
                          key={submodule.id}
                          draggableId={`submodule-${submodule.mId}`}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              ref={provided.innerRef}
                            >
                              <div style={{ marginTop: "20px" }}>
                                {<Line style={{ marginTop: "50px" }} />}
                                <ButtonContainer>
                                  <Grid container spacing={2}>
                                    <Grid
                                      item
                                      md={5}
                                      xs={12}
                                      sx={{
                                        display: { md: "flex", sx: "block" },
                                        alignItems: "center",
                                        marginTop: "20px",
                                      }}
                                    >
                                      <Box sx={{ marginLeft: "1rem" }}>
                                        <SubModuleIcon />
                                      </Box>
                                      <Box sx={{ marginLeft: "1rem" }}>
                                        <InputLabel
                                          sx={{ width: "10rem" }}
                                          htmlFor={`submodule-name-${index}`}
                                        >
                                          Sub Module Name
                                        </InputLabel>
                                      </Box>
                                      <Box sx={{ marginLeft: "1rem" }}>
                                        <TextField
                                          inputProps={{ maxLength: 60 }}
                                          sx={{ width: { xs: "100%", md: 300 } }} // Set width to 300 for md and 100% for xs
                                          // id={`sub-module-${submodule.id}`}
                                          aria-describedby={`sub-module-helper-${submodule.id}`}
                                          placeholder={
                                            formData?.submName === ""
                                              ? "Type here..."
                                              : ""
                                          }
                                          variant="outlined"
                                          value={
                                            formData?.submName || submodule?.mName
                                          }
                                          name={`sub-module-${submodule.id}`}
                                          onChange={(e) =>
                                            handleSubmoduleChange(index, e)
                                          }
                                          error={
                                            !!errors[
                                            `sub-module-${submodule?.id}`
                                            ]
                                          }
                                        />
                                        {errors[`submodule-name-${index}`] && (
                                          <FormHelperText
                                            error={true}
                                            id={`submodule-name-helper-${index}`}
                                          >
                                            {errors[`submodule-name-${index}`]}
                                          </FormHelperText>
                                        )}
                                      </Box>
                                    </Grid>
                                    <Grid
                                      item
                                      md={5}
                                      xs={12}
                                      sx={{
                                        display: { md: "flex", xs: "block" },
                                        alignItems: "center",
                                        marginTop: "20px",
                                      }}
                                    >
                                      <Box sx={{ marginLeft: "1rem" }}>
                                        <InputLabel required sx={{ width: "10rem" }}>Country</InputLabel>
                                      </Box>
                                      <Box 
                                        sx={{ 
                                          width: { xs: "100%", md: "14rem" },
                                          marginLeft: "1rem"
                                        }}
                                      >
                                        <Select
                                          multiple
                                          value={submodule.selectedCountries || []}
                                          onChange={(e) => handleSubmoduleCountryChange(e, submodule.mId)}
                                          renderValue={(selected) =>
                                            selected.map(country => country.countryName).join(", ")
                                          }
                                          MenuProps={{
                                            PaperProps: {
                                              style: {
                                                maxHeight: 250,
                                                overflowY: "auto",
                                              },
                                            },
                                          }}
                                          sx={{ width: "100%" }}
                                        >
                                          <MenuItem value="all">
                                            <ListItemIcon>
                                              <Checkbox
                                                checked={submodule.selectedCountries?.length === selectedCountries.length}
                                                icon={<img src={CheckboxUntick} />}
                                                checkedIcon={<img src={CheckboxTick} />}
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    handleSubmoduleCountryChange(
                                                      { target: { value: "selectAll" } },
                                                      submodule.mId
                                                    );
                                                  } else {
                                                    handleSubmoduleCountryChange(
                                                      { target: { value: "deselectAll" } },
                                                      submodule.mId
                                                    );
                                                  }
                                                }}
                                              />
                                            </ListItemIcon>
                                            <ListItemText primary="Select All" />
                                          </MenuItem>
                                          {selectedCountries.map((country) => (
                                            <MenuItem 
                                              key={country.countryId} 
                                              value={country}
                                            >
                                              <ListItemIcon>
                                                <Checkbox
                                                  checked={submodule.selectedCountries?.some(
                                                    selected => selected.countryId === country.countryId
                                                  )}
                                                  icon={<img src={CheckboxUntick} />}
                                                  checkedIcon={<img src={CheckboxTick} />}
                                                  onChange={() => handleSubmoduleCountryChange(
                                                    { target: { value: { ...country } } },
                                                    submodule.mId
                                                  )}
                                                />
                                              </ListItemIcon>
                                              <ListItemText primary={country.countryName} />
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </Box>
                                    </Grid>
                                    <Grid
                                      item
                                      md={2}
                                      xs={12}
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <InputLabel
                                        sx={{ width: "10rem" }}
                                      >
                                        Active
                                      </InputLabel>
                                      <Checkbox name="active"
                                        checked={submodule?.mStatus}
                                        onChange={(e) => handleDeleteSubModule(index, e.target.checked)}
                                        icon={<img src={CheckboxUntick} />}
                                        checkedIcon={<img src={CheckboxTick} />}
                                      />
                                    </Grid>
                                  </Grid>
                                </ButtonContainer>
                              </div>
                            </div>
                          )}
                        </Draggable>
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                ))}
            </DragDropContext>
          </DataContainer>
          <Box sx={{ height: "100px" }} />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 12, sm: 8, md: 12 }}
            sx={{ justifyContent: "center", marginTop: 10 }}
          >
            <ButtonContainer>
              <Button
                sx={{
                  borderRadius: 2,
                  background: "#737D86",
                  width: { xs: "100%", md: "auto" },
                }}
                variant="contained"
                disabled={loading}
                onClick={() =>
                  handleCancel()
                }

              >
                {loading && <CircularProgress size={20} />}
                Cancel
              </Button>
              <Button
                sx={{
                  borderRadius: 2,
                  background: "#102A62",
                  width: { xs: "100%", md: "auto" },
                }}
                variant="contained"
                onClick={handleUpdate}
                disabled={loading}
              >
                {loading && <CircularProgress size={20} />}
                Update
              </Button>
            </ButtonContainer>
          </Grid>
        </PaperContainer>

      </div>
    </Layout>
  );
};

export default EditRegistration;
